import React from "react";
import Partners from "../components/Partners/Partners";
import About from "../components/About/About";
import Footer from "../components/footer/Footer";
import Navbar from "../components/navbar/Navbar";

const AboutPage = () => {
  return (
    <>
      <Navbar />
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <Partners />
      <About />
      <Footer />
    </>
  );
};

export default AboutPage;
